module.exports = __webpack_public_path__ + "media/videos/Denis-Bouquet-Portfolio-60s.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/videos/Denis-Bouquet-Portfolio-60s.mp4
// module id = 152
// module chunks = 0